import { createTheme, adaptV4Theme } from '@mui/material/styles'

export const defaultPalette = {
    primary: {
        main: '#24C3CF',
        hover: '#50DEE9',
        ultraLight: '#E7F2F9',
        ultraLighter: '#E9FAFB',
        ultraFreackingLight: '#F6FDFD',
        ultraFreackingLighter: '#F7FEFE',
    },
    secondary: {
        ultraLight: '#F0EEF9',
        main: '#3b76ef',
        dark: '#2E0DA6',
    },
    mainTitleBar: {
        main: '#2f3644',
    },
    textPrimaryColor: {
        main: '#4e4c57',
    },
    lightGrey: {
        lightest: '#F8F8F8',
        light: '#FEFEFE',
        half: '#F5F7FB',
        main: '#FCFBFE',
        ultraLight: '#FBFBFE',
        mediumLight: '#f3effb',
        medium: '#DDE3E3',
        mediumDark: '#E5E9F2',
        dark: '#E5E9F2',
        darker: '#9EABBF',
        hard: '#5B6677',
        harder: '#DDE1EC',
        backgroundLight: '#F1F1F9',
        borderLight: '#E5E7EB',
        cardBackground: '#FCFCFE',
        superLight: '#F5F5FF',
        superLighter: '#F6F6FE',
        stepIcon: '#8B8B8B',
        slate: '#A8B3C9',
        muted: '#C8CBD5',
    },
    darkGrey: {
        main: '#7f8297',
    },
    white: {
        main: '#ffffff',
    },
    green: {
        ultraVeryLight: '#F3FBF7',
        main: '#26BE63',
        ultraLight: '#e6f7ec',
        shadow: 'rgba(82, 203, 148, .8)',
        ultraShadow: 'rgba(82, 203, 148, .2)',
        dark: '#016138',
        completeButton: '#4ccc50',
        completeButtonHover: '#25812a',
    },
    blue: {
        main: '#3B4DEF',
        ultraLight: '#D0D4FA',
        shadow: 'rgba(208, 212, 250, .3)',
    },
    purple: {
        main: '#8e0dea',
        ultraLight: '#dcb2fa',
        shadow: 'rgba(142, 13, 234, 0.3)',
        rippleLight: '#bbabd3',
    },
    orange: {
        ultraLight: '#FEFAF7',
        main: '#f4511e',
        dark: '#923D00',
    },
    orangeWarning: {
        main: '#FB7D08',
        half: '#FFF3E5',
        light: '#FEEAD7',
    },
    red: {
        ultraVeryLight: '#FEF7F8',
        main: '#fb355d',
        ultraLight: '#FFCED8',
        shadow: 'rgba(251, 53, 93, .12)',
        hover: '#F44E70',
        hoverUltraLight: '#f7f0f1',
    },
    consultation: {
        main: '#52CB94',
        hover: '#85DAB4',
        shadow: 'rgba(82, 203, 148, .8)',
        ultraLight: '#E7F8F0',
    },
    expertise: {
        main: '#575BAF',
        hover: '#ae88c9',
        shadow: 'rgba(142, 13, 234, 0.3)',
        black: '#000',
        buttonHover: '#464a9e',
        accent: '#4A3FCB',
        stale: '#1A1B1E',
    },
    typography: {
        main: '#313336',
        half: '#4E5054',
        hover: '#43464a',
        medium: '#9EABBF',
        mediumDark: '#6F7D93',
        light: '#808489',
        ultraLight: '#e9eaeb',
        grey: '#616F86',
        greyDark: '#555D6A',
        stepLabel: '#4B4B4B',
        stepActive: '#080808',
        stepCompleted: '#040404',
        titleDark: '#1A1A1A',
    },
    gradients: {
        hoverGradient: 'linear-gradient(0deg, #F5F5FF 0%, #F5F5FF 100%), #FFF',
        selectedGradient: 'linear-gradient(0deg, #F3F2FF 0%, #F3F2FF 100%), #FFF',
    },
    error: {
        main: '#fb355d',
        ultraLight: '#FFFAFB',
        light: '#FFF5F7',
    },
}
const idsTheme = () => {
    const defaultTheme: any = createTheme(
        adaptV4Theme({
            palette: defaultPalette,
        }),
    )

    // Creation of the theme
    const theme = createTheme(
        adaptV4Theme({
            // To be removed
            palette: defaultPalette,
            props: {
                MuiCard: {
                    elevation: 0,
                },
                MuiStack: {
                    useFlexGap: true,
                },
            },
            overrides: {
                spacing: 2,
                MuiFormControl: {
                    root: {
                        display: 'flex',
                        textAlign: 'start',
                        [defaultTheme.breakpoints.down('sm')]: {
                            justifyContent: 'center',
                        },
                    },
                },
                MuiCardHeader: {
                    root: {
                        textAlign: 'left',
                        padding: 0,
                    },
                    title: {
                        fontWeight: 'bold',
                        fontSize: '1.3rem',
                        marginBottom: '1rem',
                        padding: 0,
                        color: defaultPalette.textPrimaryColor.main,
                        [defaultTheme.breakpoints.down('sm')]: {
                            fontSize: '16px',
                        },
                    },
                },
                MuiIconButton: {
                    root: {
                        '&:hover': {
                            backgroundColor: 'none !important',
                        },
                    },
                },
                MuiCardContent: {
                    root: {
                        padding: 0,
                    },
                },
                MuiAccordionSummary: {
                    root: {
                        borderBottom: 'solid 1px #dfdfe8',
                    },
                    content: {
                        margin: '0px',
                    },
                },
                MuiAccordionDetails: {
                    root: {
                        paddingTop: '25px',
                        paddingBottom: '25px',
                    },
                },
                MuiButton: {
                    disableElevation: true,
                    root: {
                        borderRadius: '1rem',
                        padding: '.7rem 1rem',
                        fontWeight: 700,
                        textTransform: 'initial',
                        fontSize: '1rem',
                        gap: '.5rem',
                        '& .MuiButton-startIcon': {
                            marginRight: 0,
                        },
                        '> span': {
                            fontWeight: 600,
                        },
                    },
                    contained: {
                        color: '#ffffff !important',
                    },
                },
                MuiSvgIcon: {
                    root: {
                        fontSize: 'x-large',
                        [defaultTheme.breakpoints.down('sm')]: {
                            fontSize: 'large',
                        },
                    },
                    colorPrimary: {
                        color: defaultPalette.primary.main,
                    },
                    colorSecondary: {
                        color: defaultPalette.darkGrey.main,
                    },
                },
                MuiTypography: {
                    // @ts-expect-error TS(2322) FIXME: Type '{ fontFamily: string; root: { fontFamily: "A... Remove this comment to see the full error message
                    fontFamily: 'Averta',
                    fontWeight: 700,
                    fontSize: '1rem',
                    lineHeight: '1.4',
                    color: defaultPalette.typography.main,
                    h1: {
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                    },
                    h2: {
                        fontSize: '1.6rem',
                        fontWeight: 700,
                    },
                    h3: {
                        fontSize: '1rem',
                        fontWeight: 600,
                    },
                    h4: {
                        fontSize: '1rem',
                        fontWeight: 600,
                    },
                    body1: {
                        fontSize: '1rem',
                        fontWeight: 600,
                    },
                },
                MuiAppBar: {
                    root: {
                        'box-shadow': 'none',
                    },
                },
                MuiToolbar: {
                    regular: {
                        [defaultTheme.breakpoints.between('xs', 'xl')]: {
                            minHeight: 'unset',
                        },
                    },
                },
                MuiTextField: {
                    // @ts-expect-error TS(2322) FIXME: Type '{ defaultProps: { variant: string; }; }' is ... Remove this comment to see the full error message
                    defaultProps: {
                        variant: 'outlined',
                    },
                },
                MuiPopover: {
                    paper: {
                        padding: '1.5rem',
                        borderRadius: '9px',
                        boxShadow: '0px 1px 18px rgba(221,225,236,0.8)',
                        border: '1px solid rgba(221,225,236,.5)',
                    },
                },
                MuiCircularProgress: {
                    root: {
                        position: 'relative',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            border: `3px solid ${defaultPalette.primary.ultraLight}`,
                            borderRadius: '100px',
                            zIndex: 1,
                        },
                    },
                    svg: {
                        position: 'relative',
                        zIndex: 100,
                    },
                    circle: {
                        stroke: defaultPalette.primary.main,
                        strokeLinecap: 'round',
                        stokeWidth: '3px',
                    },
                },
                MuiDialog: {
                    paper: {
                        borderRadius: '1rem',
                        padding: '1.5rem',
                        maxWidth: '95%',
                        maxHeight: '95vh',
                        margin: 0,
                        [defaultTheme.breakpoints.up(820)]: {
                            minHeight: '30vh',
                            maxWidth: '55%',
                            padding: '2.5rem',
                        },
                    },
                },
                MuiDialogContent: {
                    root: {
                        padding: 0,
                    },
                },
                MuiDialogTitle: {
                    root: {
                        padding: 0,
                    },
                },
                MuiTableCell: {
                    root: {
                        fontWeight: 700,
                    },
                },
                MuiAlert: {
                    root: {
                        padding: '.6rem 1.2rem',
                        borderRadius: '12px',
                        boxShadow: '0px 1px 18px rgba(221,225,236,0.9)',
                    },
                    filledError: {
                        background: defaultPalette.red.main,
                    },
                    filledWarning: {
                        background: defaultPalette.orangeWarning.main,
                    },
                    filledInfo: {
                        background: defaultPalette.blue.main,
                    },
                    filledSuccess: {
                        background: defaultPalette.green.main,
                    },
                    action: {
                        paddingTop: 0,
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                    message: {
                        fontWeight: 600,
                        fontSize: '1rem',
                    },
                },
                MuiFormLabel: {
                    root: {
                        fontWeight: 600,
                    },
                },
                MuiInputLabel: {
                    root: {
                        '&.Mui-disabled': {
                            color: defaultPalette.typography.half,
                        },
                    },
                },
                MuiInputBase: {
                    root: {
                        fontWeight: 600,
                        '&.MuiInputBase-adornedStart > input': {
                            padding: '1rem 0',
                        },
                        '& .MuiInputBase-input': {
                            padding: '1rem',
                            height: '55px',
                            boxSizing: 'border-box',
                        },
                        '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2,
                            borderColor: defaultPalette.lightGrey.dark,
                            borderRadius: 12,
                            minHeight: '3.5rem',
                        },
                        '&.Mui-disabled': {
                            '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                borderColor: defaultPalette.lightGrey.dark,
                            },
                            '&.MuiOutlinedInput-root .MuiOutlinedInput-input': {
                                '&::placeholder': {
                                    color: defaultPalette.lightGrey.darker,
                                },
                                color: `${defaultPalette.lightGrey.darker}`,
                                WebkitTextFillColor: `${defaultPalette.lightGrey.darker}`,
                            },
                        },
                        '&.Mui-error': {
                            borderColor: defaultPalette.red.main,
                        },
                        '&.MuiOutlinedInput-root .MuiOutlinedInput-input': {
                            '&::placeholder': {
                                opacity: 1,
                                color: defaultPalette.lightGrey.darker,
                            },
                        },
                    },
                },
                MuiOutlinedInput: {
                    // @ts-expect-error TS(2322) FIXME: Type '{ borderWidth: number; borderColor: any; }' ... Remove this comment to see the full error message
                    borderWidth: 2,
                    borderColor: defaultPalette.lightGrey.medium,
                },
                MuiAutocomplete: {
                    inputRoot: {
                        minHeight: '3.5rem',
                    },
                    loading: {
                        color: defaultPalette.typography.medium,
                        fontWeight: 600,
                        fontSize: '14px',
                        padding: '1rem',
                    },
                },
                MuiSkeleton: {
                    root: {
                        background: defaultPalette.lightGrey.dark,
                    },
                    rounded: {
                        borderRadius: '1rem',
                    },
                },
                MuiDivider: {
                    root: {
                        height: '2px',
                        background: defaultPalette.lightGrey.light,
                        borderRadius: '100px',
                        width: '100%',
                    },
                },
                MuiTooltip: {
                    tooltip: {
                        backgroundColor: '#ffffff',
                        color: defaultPalette.typography.main,
                        padding: '16px',
                        boxShadow: '0px 1px 14px 0px rgba(106, 109, 115, 0.26)',
                        fontSize: '.875rem',
                        borderRadius: '.5rem',
                        fontWeight: 600,
                        margin: 'unset',
                    },
                    arrow: {
                        color: '#ffffff',
                    },
                },
            },
        }),
    )
    // For now we remove some box-shadows with this
    // eslint-disable-next-line prefer-destructuring
    theme.shadows[5] = theme.shadows[1]
    // eslint-disable-next-line prefer-destructuring
    theme.shadows[1] = theme.shadows[0]

    return theme
}

export default idsTheme
